import {Queries} from '../../api/queries';
import Layout from '../Layout';
import TagToken from './TagToken';
import {Box} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {type Tag} from 'shared/src/models';

const TagManagement = () => {
	const {data: tags} = useQuery(Queries.tags());

	return (
		<Layout>
			<Layout.Header title='Tags' />
			<Layout.Body>
				<Box
					width='100%'
					border='500'
					borderColor='container.border.base'
					borderRadius='outer'
					bg='white'
					p='space.300'
					display='flex'
					flexDirection='column'
					rowGap='space.400'
				>
					{tags
						?.filter((tag) => !tag.parentTagId)
						.map((tag) => <TagTree key={tag.id} tag={tag} allTags={tags!} />)}
				</Box>
			</Layout.Body>
		</Layout>
	);
};

interface TagTreeProps {
	tag: Tag;
	allTags: Tag[];
	depth?: number;
}

const TagTree = ({tag, allTags, depth = 0}: TagTreeProps) => {
	return (
		<Box display='flex' flexDirection='column' ml={depth * 12} rowGap='space.200'>
			<TagToken id={tag.id} closeable={false} />
			{allTags
				.filter((childTag) => childTag.parentTagId === tag.id)
				.map((childTag) => (
					<TagTree key={childTag.id} tag={childTag} allTags={allTags} depth={depth + 1} />
				))}
		</Box>
	);
};

export default TagManagement;
